
  <p *ngIf="secretaryActive.length > 0">
    <b>Caso precise de ajuda você pode entrar em contato com uma das secretarias abaixo.</b>
  </p>

  <div class="col-xs-12 col-lg-6" *ngFor="let secretary of secretaryActive">
    <mat-card>
      <div class="row">
        <div class="col-xs-5 col-md-3 col-lg-2">
          <div class="image"><page-avatar [gender]="secretary?.gender" [avatar]="secretary?.avatar"></page-avatar></div>
        </div>
        <div class="col-xs-7 col-md-9 col-lg-10 data">
          <b>Nome: {{ secretary.name }}</b> <br />
          <b>Telefone: {{ secretary.telecom[1].value }}</b>
        </div>
      </div>
    </mat-card>
  </div>

